import { render, staticRenderFns } from "./JiaolianList.vue?vue&type=template&id=46d1ee40&scoped=true&"
import script from "./JiaolianList.vue?vue&type=script&lang=js&"
export * from "./JiaolianList.vue?vue&type=script&lang=js&"
import style0 from "./JiaolianList.vue?vue&type=style&index=0&id=46d1ee40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d1ee40",
  null
  
)

export default component.exports